<script>
    // @ts-nocheck
    export let isOpen = false
    export let options = []
    export let links = []
    import user from '../../stores/user'
    import { tick } from 'svelte'
    import { toTitleCase } from '$lib/utils'
    import { useLocation, navigate } from 'svelte-navigator'
    import { Svroller } from 'svrollbar'
    import { Avatar, Typography, Link } from '../UI/'
    let conf = {
        li: { type: 'body', style: 'padding: 0;margin: 0' },
    }
    const location = useLocation()
    const toggle = (_) => {
        isOpen = !isOpen
    }
    // @ts-ignore
    let name = toTitleCase($user?.name + ' ' + $user?.lastName)
</script>

<div class="main">
    <Svroller width="364px" height="100%" alwaysVisible>
        <span>
            <span
                style="margin: 26px 0 34px 70px; height: 70px;gap: 18px; flex-direction: columns;align-items: center; justify-content: center"
            >
                <span style="width: 62px;">
                    <Avatar type="flat" name={$user?.shortName} />
                </span>
                <span
                    style="flex-direction: column; width: 100%; justify-content: center; gap: 4px; align-items: flex-start"
                >
                    <Typography
                        type="h4"
                        style="margin: 0;padding: 0"
                        color="white">{$user?.shortName}</Typography
                    >
                    <Link style="color: white" href="/home/profile"
                        >Administrar usuario</Link
                    >
                </span>
            </span>
        </span>
        <ul>
            {#each options as { path, label }}
                <li
                    class:active={$location.pathname === path}
                    on:click={(_) => {
                        navigate(path)
                        isOpen = false
                    }}
                >
                    <Typography {...conf.li}>{label}</Typography>
                </li>
            {/each}
        </ul>
        <ul style="background: transparent;">
            {#each links as { label, link }}
                <li
                    on:click={(_) => {
                        window.open(link, '_blank')
                    }}
                >
                    <Typography {...conf.li}>{label}</Typography>
                </li>
            {/each}
        </ul>
        <slot />
    </Svroller>
    <ul style="position: relative; background: transparent;">
        <li
            on:click={(_) => {
                user.logout('')
            }}
        >
            <Typography {...conf.li}>Cerrar sesión</Typography>
        </li>
    </ul>
</div>

<style>
    span {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
    }
    .main {
        background: var(--color-brand-primary-01);
        width: 364px;
        /* height: calc(100vh - 70px); */
        height: calc(100% - 70px);
        display: grid;
        top: 0px;
        /* position: -webkit-sticky; Safari */
        position: fixed;
        z-index: 9;
        grid-template-rows: calc(100% - 70px) 70px;
        /* position: relative; */
        justify-content: flex-start;
        align-items: flex-start;
        --svrollbar-thumb-background: #ffffff;
        --svrollbar-track-opacity: 0.9;
        --svrollbar-track-background: var(--color-accent-01);
        --svrollbar-thumb-opacity: 1;
        --svrollbar-track-width: 7px;
        --svrollbar-thumb-width: 7px;
    }
    span {
        width: 100%;
        background: var(--color-accent-01);
        position: relative;
        height: auto;
        display: flex;
        /* border-left: 8px #ffffff solid; */
    }
    ul {
        color: var(--color-white);
        list-style: none;
        background: var(--color-accent-01);
        margin: 0;
        padding: 16px 0 0 0;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    li {
        height: 60px;
        margin: 0;
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 0 0 70px;
        cursor: pointer;
        position: relative;
        user-select: none;
    }
    li:hover {
        opacity: 0.8;
    }
    li.active::before {
        height: 100%;
        margin: 0 0 0 -70px;
        padding: 0 0 0 62px;
        border-left: 8px var(--color-white) solid;
        content: '';
    }
</style>
